'use client'

import React, { Dispatch } from 'react'
import SearchMobile from './search.mobile'

const Search = ({
  open,
  setOpen,
}: {
  open?: boolean
  setOpen?: Dispatch<boolean>
}) => {
  return <SearchMobile open={open} setOpen={setOpen} />
}

export default Search
